var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('legend', [_vm._v("Marking Misroute ODA")]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.getShipDataLoader
    },
    on: {
      "update:active": function($event) {
        _vm.getShipDataLoader = $event
      }
    }
  }), _vm._v(" "), _c('form', {
    attrs: {
      "data-vv-scope": "form-1"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validateForm('form-1')
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(0), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-3"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ShipmentType),
      expression: "ShipmentType"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|'),
      expression: "'required|'"
    }],
    staticClass: "form-control",
    class: {
      'input': true,
      'is-danger': _vm.errors.has('form-1.ShipmentType')
    },
    attrs: {
      "id": "ShipmentType",
      "name": "ShipmentType"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.ShipmentType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("-- Select shipment type --")]), _vm._v(" "), _vm._l((_vm.shipmentTypeObj), function(shipmentType_obj) {
    return _c('option', {
      domProps: {
        "value": shipmentType_obj.id
      }
    }, [_vm._v(_vm._s(shipmentType_obj.type))])
  })], 2)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.ShipmentType')),
      expression: "errors.has('form-1.ShipmentType')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please select Shipment Type. ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-3"
  }, [_c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.MarkShipmentStatus),
      expression: "MarkShipmentStatus"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('MarkShipmentStatus')
    },
    attrs: {
      "id": "MarkShipmentStatus",
      "name": "MarkShipmentStatus"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.MarkShipmentStatus = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.CheckShipmentStatus()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("--Select shipment status--")]), _vm._v(" "), _vm._l((_vm.shipmentStatusObj), function(shipmentStatus_obj) {
    return _c('option', {
      domProps: {
        "value": shipmentStatus_obj.uniquecode
      }
    }, [_vm._v(_vm._s(shipmentStatus_obj.userprocess))])
  })], 2)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.MarkShipmentStatus')),
      expression: "errors.has('form-1.MarkShipmentStatus')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please select Mark Shipment Status.")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(2), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-3"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.txtShipment),
      expression: "txtShipment"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('txtShipment')
    },
    attrs: {
      "id": "txtShipment",
      "type": "text",
      "name": "txtShipment",
      "placeholder": "Enter AWB Number"
    },
    domProps: {
      "value": (_vm.txtShipment)
    },
    on: {
      "change": _vm.getReqShipmentData,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.txtShipment = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.txtShipment')),
      expression: "errors.has('form-1.txtShipment')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please enter AWB Number.")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(3), _vm._v(" "), (_vm.isGeoPincodesAndHub == false || !_vm.isGeoFlowEnabled) ? _c('b-input-group', {
    staticClass: "col-md-3",
    attrs: {
      "right": _vm.isPincodeLoader
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.txtPincode),
      expression: "txtPincode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (("" + (_vm.MarkShipmentStatus == 'XBU00260' ? 'required|numeric|max:6|min:6' : 'numeric|max:6|min:6'))),
      expression: "`${MarkShipmentStatus == 'XBU00260' ? 'required|numeric|max:6|min:6' : 'numeric|max:6|min:6'}`"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('txtPincode')
    },
    attrs: {
      "id": "txtPincode",
      "type": "text",
      "name": "txtPincode",
      "placeholder": "Enter correct pincode",
      "disabled": !_vm.isCorrectPinInput
    },
    domProps: {
      "value": (_vm.txtPincode)
    },
    on: {
      "keypress": _vm.onlyNumber,
      "change": _vm.gethubagainstAWBandPincode,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.txtPincode = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.isGeoPincodesAndHub == true && _vm.isGeoFlowEnabled) ? _c('b-input-group', {
    staticClass: "col-md-3"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.geoPincode),
      expression: "geoPincode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|'),
      expression: "'required|'"
    }],
    staticClass: "form-control",
    class: {
      'input': true,
      'is-danger': _vm.errors.has('form-1.geoPincode')
    },
    attrs: {
      "id": "geoPincode",
      "name": "geoPincode"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.geoPincode = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("-- Select correct Pincode --")]), _vm._v(" "), _vm._l((_vm.geoPincodeList), function(pincode) {
    return _c('option', {
      domProps: {
        "value": pincode
      }
    }, [_vm._v(_vm._s(pincode))])
  })], 2)]) : _vm._e(), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.txtPincode')),
      expression: "errors.has('form-1.txtPincode')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please Enter Correct Pincode.")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-4"
  }, [(_vm.ODAerror != '') ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.ODAerror))]) : _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.ODAerror))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(4), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-3",
    attrs: {
      "right": _vm.ReasonLoader
    }
  }, [_c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.ddlMisrouteReason1),
      expression: "ddlMisrouteReason1"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('ddlMisrouteReason1')
    },
    attrs: {
      "id": "ddlMisrouteReason1",
      "name": "ddlMisrouteReason1"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.ddlMisrouteReason1 = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("--Select reason--")]), _vm._v(" "), _vm._l((_vm.reasonObj), function(Reason_obj) {
    return _c('option', {
      domProps: {
        "value": Reason_obj.Reason
      }
    }, [_vm._v(_vm._s(Reason_obj.Reason))])
  })], 2)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.ddlMisrouteReason1')),
      expression: "errors.has('form-1.ddlMisrouteReason1')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please select Reason.")])], 1)]), _vm._v(" "), (_vm.hubDiv == true) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [(_vm.hubFlag == true) ? _c('div', {
    staticClass: "input-group-prepend col-md-2"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("Select Hub :")])]) : _vm._e(), _vm._v(" "), (_vm.HubLabelFlag == true) ? _c('div', {
    staticClass: "col-md-2"
  }, [_c('b-input-group', [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isHubLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isHubLoading = $event
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.hub))])], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.isCorrectPinInput && _vm.hub && !_vm.isRTODTO) ? _c('span', {
    staticClass: "text-danger",
    staticStyle: {
      "margin-left": "100px"
    }
  }, [_vm._v(_vm._s('Shipment for the given address was previously delivered from the ' + this.hub + ' facility.'))]) : _vm._e(), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.ddlHub')),
      expression: "errors.has('form-1.ddlHub')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please select hub.")])])]) : _vm._e(), _vm._v(" "), (_vm.DistanceFlag == true) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(5), _vm._v(" "), _c('b-input-group', {
    staticClass: "col-md-3",
    attrs: {
      "if": "HubLabelFlag == false"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.DistanceKm),
      expression: "DistanceKm"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        IsValidNo: true,
        IsValidDist: true
      }),
      expression: "{required: true,IsValidNo:true,IsValidDist:true}"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('DistanceKm')
    },
    attrs: {
      "id": "DistanceKm",
      "type": "text",
      "name": "DistanceKm",
      "placeholder": "Enter distance"
    },
    domProps: {
      "value": (_vm.DistanceKm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.DistanceKm = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.DistanceKm')),
      expression: "errors.has('form-1.DistanceKm')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('form-1.DistanceKm')))])], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "type": "submit",
      "disabled": _vm.isSubmitLoading
    }
  }, [_c('i', {
    staticClass: "fa fa-dot-circle-o"
  }), _vm._v("Save")]), _vm._v(" "), _c('span', {
    staticClass: "btn btn-sm btn-danger",
    on: {
      "click": _vm.clear
    }
  }, [_c('i', {
    staticClass: "fa fa-ban",
    on: {
      "click": _vm.clear
    }
  }), _vm._v("Clear")]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isSubmitLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isSubmitLoading = $event
      }
    }
  })], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12"
  }, [_c('b-alert', {
    attrs: {
      "show": _vm.dismissCountDown,
      "dismissible": "",
      "fade": "",
      "variant": "success"
    },
    on: {
      "dismiss-count-down": _vm.countDownChanged,
      "dismissed": _vm.CloseSuccessErrorRes
    }
  }, [(_vm.requestsSuccMsg.length > 0) ? _c('div', {
    staticClass: "alert alert-success"
  }, [_vm._l((_vm.requestsSuccMsg), function(item) {
    return [_c('span', [_vm._v(_vm._s(item.Shipment) + " :- " + _vm._s(item.message))]), _c('br')]
  })], 2) : _vm._e(), _vm._v(" "), (_vm.requestsErrMsg.length > 0) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_vm._l((_vm.requestsErrMsg), function(item) {
    return [_c('span', [_vm._v(_vm._s(item.Shipment) + " :- " + _vm._s(item.message))]), _c('br')]
  })], 2) : _vm._e()])], 1)])])])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-2"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("Select Shipment Type ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-2"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("Mark Shipment Status ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-2"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("Enter AWB No")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-2"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("Correct Pincode")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-2"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("Reason ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend col-md-2"
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v("Distance(KM) : ")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02fc27ee","hasScoped":true}!./src/views/components/MarkingMisrouteODA/MarkingMisrouteODA.component.html
// module id = 1004
// module chunks = 1